// import { useState } from "react";
// import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

// const StatCard = ({ label, value, sub, color, compact, urgent }) => (
//   <Box
//     sx={{
//       background: "#fff",
//       borderLeft: `3px solid ${color}`,
//       borderRadius: "6px",
//       padding: "10px 14px",
//       display: "flex",
//       boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
//       ...(compact
//         ? {
//             alignItems: "center",
//             gap: 0.75,
//             p: "8px 12px 8px 14px",
//             minWidth: "fit-content",
//           }
//         : {
//             p: "14px 16px",
//             pl: "20px",
//             flex: 1,
//             minWidth: 130,
//             flexDirection: "column",
//             justifyContent: "space-between",
//             minHeight: "66px",
//           }),
//     }}
//   >
//     {/* <Box
//       sx={{
//         position: "absolute",
//         left: 0,
//         top: 0,
//         bottom: 0,
//         width: "3px",
//         backgroundColor: color,
//       }}
//     /> */}

//     {urgent && value > 0 && (
//       <Box
//         sx={{
//           position: "absolute",
//           top: 6,
//           right: 6,
//           width: 8,
//           height: 8,
//           borderRadius: "50%",
//           backgroundColor: "#E8842C",
//           "@keyframes pulse": {
//             "0%": { boxShadow: "0 0 0 0 rgba(232,132,44,0.5)" },
//             "70%": { boxShadow: "0 0 0 6px rgba(232,132,44,0)" },
//             "100%": { boxShadow: "0 0 0 0 rgba(232,132,44,0)" },
//           },
//           animation: "pulse 1.8s infinite",
//         }}
//       />
//     )}

//     {compact ? (
//       <>
//         <Box
//           sx={{
//             fontSize: "13.5px",
//             fontWeight: 700,
//             color: "#12181A",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {value}
//         </Box>
//         <Box
//           sx={{
//             fontSize: "11px",
//             fontWeight: 600,
//             color: "#66766F",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {label}
//         </Box>
//       </>
//     ) : (
//       <>
//         <Box
//           sx={{ fontSize: "11px", fontWeight: 600, color: "#66766F", mb: 0.75 }}
//         >
//           {label}
//         </Box>
//         <Box
//           sx={{
//             fontSize: "13.5px",
//             fontWeight: 700,
//             letterSpacing: "-0.02em",
//             color: "#12181A",
//           }}
//         >
//           {value}
//         </Box>
//         {sub && (
//           <Box sx={{ fontSize: "11px", color: "#98A6A0", mt: 0.25 }}>{sub}</Box>
//         )}
//       </>
//     )}
//   </Box>
// );

// const StatGroup = ({ title, stats, compact }) => {
//   if (!stats?.length) return null;

//   return (
//     <Box sx={{ mb: 1.5 }}>
//       {title && (
//         <Typography
//           sx={{
//             fontSize: 11.5,
//             fontWeight: 700,
//             color: "#98A6A0",
//             textTransform: "uppercase",
//             letterSpacing: "0.04em",
//             mb: 0.75,
//             ml: 0.25,
//           }}
//         >
//           {title}
//         </Typography>
//       )}
//       <Box
//         sx={
//           compact
//             ? {
//                 display: "flex",
//                 gap: 1,
//                 overflowX: "auto",
//                 pb: 0.5,
//                 "&::-webkit-scrollbar": { display: "none" },
//                 scrollbarWidth: "none",
//               }
//             : {
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
//                 gap: "10px",
//               }
//         }
//       >
//         {stats.map((stat) => {
//           if (stat.key === "CHANGES_REQUESTED" && stat.value === 0) {
//             return;
//           }
//           return <StatCard key={stat.label} {...stat} compact={compact} />;
//         })}
//       </Box>
//     </Box>
//   );
// };

// // Segmented toggle for switching between groups on mobile
// const GroupToggle = ({ groups, activeIndex, onChange }) => (
//   <Box
//     sx={{
//       display: "inline-flex",
//       backgroundColor: "#F0F4F2",
//       borderRadius: 2,
//       p: "3px",
//       mb: 1,
//     }}
//   >
//     {groups.map((group, i) => (
//       <Box
//         key={group.title}
//         onClick={() => onChange(i)}
//         sx={{
//           px: 1.5,
//           py: 0.5,
//           borderRadius: 1.5,
//           fontSize: 12,
//           fontWeight: 600,
//           cursor: "pointer",
//           whiteSpace: "nowrap",
//           color: activeIndex === i ? "#0B5F56" : "#66766F",
//           backgroundColor: activeIndex === i ? "#fff" : "transparent",
//           boxShadow:
//             activeIndex === i ? "0 1px 2px rgba(16,24,22,0.08)" : "none",
//           transition: "all 0.15s ease",
//         }}
//       >
//         {group.title}
//       </Box>
//     ))}
//   </Box>
// );

// const StatsStrip = ({ stats = [], groups = [] }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const [activeGroup, setActiveGroup] = useState(0);

//   if (groups.length) {
//     if (isMobile && groups.length > 1) {
//       return (
//         <Box sx={{ mb: 2 }}>
//           <GroupToggle
//             groups={groups}
//             activeIndex={activeGroup}
//             onChange={setActiveGroup}
//           />
//           <StatGroup stats={groups[activeGroup].stats} compact />
//         </Box>
//       );
//     }

//     return (
//       <Box sx={{ mb: 2.5 }}>
//         {groups.map((group) => (
//           <StatGroup
//             key={group.title}
//             title={group.title}
//             stats={group.stats}
//             compact={isMobile}
//           />
//         ))}
//       </Box>
//     );
//   }

//   if (!stats.length) return null;

//   return (
//     <Box
//       sx={
//         isMobile
//           ? {
//               display: "flex",
//               gap: 1,
//               overflowX: "auto",
//               mb: 2,
//               pb: 0.5,
//               "&::-webkit-scrollbar": { display: "none" },
//               scrollbarWidth: "none",
//             }
//           : {
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
//               gap: "10px",
//             }
//       }
//     >
//       {stats.map((stat) => (
//         <StatCard key={stat.label} {...stat} compact={isMobile} />
//       ))}
//     </Box>
//   );
// };

// export default StatsStrip;

import { useState, useEffect } from "react";

function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function useIsMobile(breakpoint = 600) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
}

function Tile({ label, value, color, icon: Icon }) {
  const dim = value === 0;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 10px 6px 6px",
        borderRadius: "10px",
        background: hexToRgba(color, 0.08),
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: "26px",
          height: "26px",
          borderRadius: "8px",
          background: hexToRgba(color, 0.18),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {Icon && <Icon size={14} color={color} strokeWidth={2.2} />}
      </div>
      <div
        style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}
      >
        <span
          style={{
            fontSize: "13.5px",
            fontWeight: 700,
            color: "#12181A",
          }}
        >
          {value}
        </span>
        <span
          style={{ fontSize: "11px", color: "#8A968F", whiteSpace: "nowrap" }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}

function Row({ title, items, scrollable }) {
  if (!items?.length) return null;
  return (
    <div>
      {title && (
        <div
          style={{
            fontSize: "11px",
            fontWeight: 600,
            color: "#98A6A0",
            textTransform: "uppercase",
            letterSpacing: "0.04em",
            marginBottom: "6px",
          }}
        >
          {title}
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexWrap: scrollable ? "nowrap" : "wrap",
          overflowX: scrollable ? "auto" : "visible",
          gap: "4px",
          paddingBottom: scrollable ? "4px" : 0,
          scrollbarWidth: "none",
        }}
      >
        {items.map((item) => (
          <Tile key={item.label} {...item} />
        ))}
      </div>
    </div>
  );
}

function GroupToggle({ groups, activeIndex, onChange }) {
  return (
    <div
      style={{
        display: "inline-flex",
        backgroundColor: "#F0F4F2",
        borderRadius: "10px",
        padding: "3px",
        marginBottom: "8px",
      }}
    >
      {groups.map((group, i) => (
        <div
          key={group.title}
          onClick={() => onChange(i)}
          style={{
            padding: "5px 12px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: 600,
            cursor: "pointer",
            whiteSpace: "nowrap",
            color: activeIndex === i ? "#0B5F56" : "#66766F",
            backgroundColor: activeIndex === i ? "#fff" : "transparent",
            boxShadow:
              activeIndex === i ? "0 1px 2px rgba(16,24,22,0.08)" : "none",
            transition: "all 0.15s ease",
          }}
        >
          {group.title}
        </div>
      ))}
    </div>
  );
}

export default function StatsIconTiles({ groups = [], stats = [] }) {
  const isMobile = useIsMobile();
  const [activeGroup, setActiveGroup] = useState(0);

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    background: "#fff",
    border: "1px solid #EEF0F2",
    borderRadius: "14px",
    padding: "16px 18px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    marginBottom: "10px",
  };

  if (groups.length) {
    if (isMobile && groups.length > 1) {
      return (
        <div style={wrapperStyle}>
          <GroupToggle
            groups={groups}
            activeIndex={activeGroup}
            onChange={setActiveGroup}
          />
          <Row items={groups[activeGroup].stats} scrollable />
        </div>
      );
    }

    return (
      <div style={wrapperStyle}>
        {groups.map((g) => (
          <Row
            key={g.title}
            title={g.title}
            items={g.stats}
            scrollable={isMobile}
          />
        ))}
      </div>
    );
  }

  if (!stats.length) return null;

  return (
    <div style={wrapperStyle}>
      <Row items={stats} scrollable={isMobile} />
    </div>
  );
}
